import React from "react";
import { FaStar } from "react-icons/fa";
import { motion } from "framer-motion";
import "./ClassesSection.css";

// Import your images
import prof from "../Assets/Professionals.png";
import entre from "../Assets/Entrepreneurs.png";
import strudents from "../Assets/Students.png";
import homem from "../Assets/home.png";

const ClassesSection = () => {
  // Only 4 courses now
  const courses = [
    {
      title: "Professionals",
      desc: <>
      <ul>
        <li>Communicate fluently in meetings and presentations</li>
         <li>Write and speak confidently in emails, online meetings and workplace discussions</li>
          <li>Build the communication skills needed for career growth and promotions</li>
           <li>Profession specific courses – Lawyers, Doctors, IT professionals, Call centre/BPO employees, Teachers, Sales personnel, etc.</li>
      </ul>
      </>,
      img: prof,
    },
    {
      title: "Entrepreneurs",
      desc: <>
      <ul>
        <li>Impress clients with clear and professional English</li>
         <li>Make a lasting and impressive sales & marketing pitch</li>
          <li>Network confidently to expand your business connections</li>
           <li>Gain the skills to present your ideas and brand globally</li>
      </ul>
      </>,
      img: entre,
    },
     {
      title: "Students",
      desc: <>
      <ul>
        <li>Speak confidently in classrooms and campus conversations</li>
         <li>Perform better in exams, presentations, and debates</li>
          <li>Prepare effectively for interviews and group discussions on various platforms</li>
           <li>Structured training for <b>TOEFL and IELTS</b>, designed to boost your score and open doors for international education</li>
      </ul>
      </>,
      img: strudents,
    },
    {
      title: "Homemakers",
      desc: <>
      <ul>
        <li>Assist your children with homework and assignments from their school</li>
         <li>Speak confidently during parent-teacher meetings</li>
          <li>Build self-confidence and gain respect in social gatherings</li>
           <li>Open the door to endless learning — explore new skills and follow global tutorials, like YouTube, Facebook and Google in your free time</li>
           <li>Develop the ability to create and share your own English videos on social media platforms</li>
      </ul>
      </>,
      img: homem,
    },
  ];

  const renderCourseCard = (course, index) => (
    <motion.div
      className="coursee-card"
      key={index}
      initial={{ opacity: 0, scale: 0.9, y: 30 }}
      whileInView={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.6, delay: index * 0.2 }}
      viewport={{ once: true }}
    >
      <img src={course.img} alt={course.title} className="coursee-image" />
      <div className="coursee-content">
        <h3>{course.title}</h3>
        <p>{course.desc}</p>
        <div className="coursee-footer">
          <a href="/enroll-for-course" className="enroll-btn">Enroll Now</a>
        </div>
      </div>
    </motion.div>
  );

  return (
    <section className="classes-section">
      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: -40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
      How Our Online Courses Benefit You
      </motion.h2>

      <motion.p
        className="section-desc"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.3 }}
        viewport={{ once: true }}
      >
        At <b>NewZeal Language Academy</b>, our Spoken English courses are thoughtfully designed to take you from your current level of 
        English to the next level with confidence. <br/><br/> We offer <b>online only</b>, customized courses for students, professionals, entrepreneurs and homemakers. <br/><br/> Each program is carefully structured to provide <b>practical, real-life benefits</b> and to support learners from all walks of life. We focus on helping the following groups achieve their specific goals:
      </motion.p>

      {/* Grid layout with 4 cards */}
      <div className="courses-grid">
        {courses.map(renderCourseCard)}
      </div>
    </section>
  );
};

export default ClassesSection;
